<template>
  <div id="app" style="overflow-x: hidden">
    <div class="pc-block">
      <header class="app_header">
        <div class="logo">
          <img src="@/assets/img/homeLogon.png" alt="" />
        </div>
        <div class="app_header_menuList">
          <div
            v-for="menuLists in menuList"
            :key="menuLists.id"
            class="item"
            @mouseover="mouseoverToStyle"
            @mouseout="mouseoutToStyle"
            :class="selectMenuItemPath == menuLists.id ? 'actived' : ''"
            @click="toPath(menuLists)"
          >
            <p class="zh">{{ menuLists.label }}</p>
            <p class="en">{{ menuLists.menuEnName }}</p>
          </div>
        </div>
      </header>
    </div>

    <!-- <div class="pc-none">
      <header class="app_header">
        <div class="logo">
          <img src="@/assets/img/homeLogon.png" alt="" />
        </div>
        <h3>长寿博物馆官网</h3>
        <span class="el-icon-s-operation"></span>
      </header>
    </div> -->

    <!-- 电脑端头部结束 -->
    <!-- 手机端头部开始 -->
    <div class="pc-none">
      <header class="phoneHeader">
        <div class="phoneLogo">
          <div class="logo">
          <img src="@/assets/img/homeLogon.png" alt="" />
        </div>
        <h3>长寿博物馆官网</h3>
          <div class="headerBottom">
            <div class="phoneList">
              <span
                class="line"
                :class="{ active: showPhoneHeader }"
                @click="phoneListFun"
              ></span>
            </div>
          </div>
        </div>
        <div class="phoneMenuList" :class="{ active: showPhoneHeader }">
          <div
            class="firstItem"
            v-for="(item, index) in phoneMenuList"
            :key="index"
          >
            <div class="one">
              <span class="txt" @click="toPath(item)">{{ item.label }}</span>
              <span
                class="icon"
                :class="{ active: index == menuIndex }"
                v-if="item.children && item.children.length > 0"
                @click="childMenuFun(index)"
              >
                <i class="el-icon-arrow-down"></i>
              </span>
            </div>
            <div
              class="two"
              :style="{
                height:
                  index == menuIndex ? item.children.length * 45 + 'px' : '',
              }"
            >
              <div
                class="item"
                v-for="childItem in item.children"
                :key="childItem.id"
                @click="childMenuToTath(childItem, item.id)"
              >
                {{ childItem.label }}
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
    <!-- banner -->
    <div class="commonBanner" v-if="selectMenuItemPath != 138">
      <img
        :src="
          oneMenuInfo && oneMenuInfo.menuBanner
            ? ips + oneMenuInfo.menuBanner
            : ''
        "
        alt
        height="509"
        width="100%"
        style="object-fit: cover"
      />
    </div>
    <div
      class="banner_scroll mobileTerminal"
      v-else
      @mouseover="mouseOver1"
      @mouseleave="mouseLeave1"
    >
      <ul v-if="banner_imgArr && banner_imgArr.length > 0">
        <li
          v-for="(banner_imgArrs, index1) in banner_imgArr"
          class="banner_scroll_item"
          :key="index1"
          :class="banner_index == index1 ? 'actived_li' : 'default_li'"
        >
          <img
            :src="
              banner_imgArrs && banner_imgArrs.imgUrl
                ? ips + banner_imgArrs.imgUrl
                : ''
            "
            alt=""
            height="100%"
          />
        </li>
      </ul>
    </div>
    <!-- 右侧广告 -->
    <!-- <div class="stickiness">
      <a href="https://wx.qq.com/"
         target="_blank">
        <div class="greyBox">
          <img src="@/assets/img/weixin.png"
               alt=""
               width="26"
               height="26">
          <div>微信</div>
        </div>
      </a>
      <a href="https://passport.weibo.com/"
         target="_blank">
        <div class="greyBox">
          <img src="@/assets/img/weibo.png"
               alt=""
               width="26"
               height="26">
          <div>微博</div>
        </div>
      </a>
      <div class="greyBox"
           @click="openCode">
        <img src="@/assets/img/yuyue.png"
             alt=""
             width="26"
             height="26">
        <div>预约</div>
      </div>
    </div> -->
    <router-view />
    <footer class="footer_style">
      <div class="footer_left">
        <div>
          网站访问量
          <span
            class="PageView"
            v-for="(item, index) in PageView"
            :key="index"
            >{{ item }}</span
          >
        </div>
        <div style="margin-bottom: 16px">{{ Internet.InternetRegion }}</div>
        <div class="beanhao">
          <img src="./assets/img/备案图标.png" width="19" alt="" />
          <a
            href="https://beian.mps.gov.cn/#/query/webSearch?code=50011502001143"
            rel="noreferrer"
            target="_blank"
            >渝公网安备50011502001143号</a
          >
          <span class="pc-none" >
            <br>
          </span>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <a href="http://beian.miit.gov.cn/" target="_blank">{{
            Internet.InternetNUmber
          }}</a>
        </div>

        <div class="GovernmentLink">
          <!-- <p>
          <a href="https://www.gzlps.gov.cn/" rel="noreferrer" target="_blank"
            ></a
          >
        </p>
        <p>
          <a href="https://www.gzmuseum.com/" class="gzmuseum" rel="noreferrer" target="_blank"
            ></a
          >
        </p>
        <p>
          <a href="https://www.gzzs.gov.cn/" class="zhonshan" rel="noreferrer" target="_blank"
            ></a
          >
        </p> -->
        </div>
      </div>
      <img
        src="./assets/img/institution.png"
        alt=""
        class="institution"
        width="48"
        height="59"
      />
    </footer>
    <el-dialog title="二维码" :visible.sync="ewmDia" width="25rem" center>
      <div class="ewmDiv">
        <!-- <img src="./assets/img/wechartEwm.png" alt="" /> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  menuTreeApi,
  menuListApi,
  configKeyApi,
  getOneMenuInfo, //获取一级菜单信息
} from "./assets/js/api.js";
import { getBanner, getHomeBanner } from "./assets/js/commonFun.js";
export default {
  name: "App",
  data() {
    return {
      errorImg: 'this.src="' + require("./assets/img/errorImg.jpg") + '"',
      isActive: false,
      timer: null,
      selectedValue: 1,
      selectMenuItemPath: "",
      menuList: [],
      isZh: true,
      showPhoneHeader: false,
      menuIndex: null,
      name: "home",
      ips: "",
      oneMenuInfo: null,
      phoneMenuList: [],
      banner_imgArr: [] /* banner图 */,
      banner_index: 0,
      time_banner: null,
      /**二维码弹框 */
      ewmDia: false,
      Internet: {},
      PageView: 0,
    };
  },
  created() {
    this.getIp();
    this.Internet = window.Internet;
  },
  async mounted() {
     console.log(546);
    this.$nextTick(() => {
      // this.activePostion(this.$route.name);
    });
    this.getBanner();
    await this.configKey();
    let languageSet = localStorage.getItem("languageSet") || "zh";
    if (languageSet === "zh") {
      this.isZh = true;
    } else {
      this.isZh = false;
    }
    this.getMenuTree();
  },
  beforeDestroy() {
    clearInterval(this.time_banner);
    this.time_banner = null;
  },
  watch: {
    $route: {
      handler(route) {
        this.name = route.name;
        this.$nextTick(() => {
          // this.activePostion(this.name);
        });
        this.selectMenuItemPath = route.params.id ? route.params.id : 138;
        // if (route.params.id) {
        this.getOneMenuInfoFun(this.selectMenuItemPath);
        // }
      },
      immediate: true,
    },
  },
  methods: {
        /**二级菜单点击跳转 */
    childMenuToTath(item, parentId) {
     
      
      window.scrollTo(0, 0)
      document.body.scrollTop = 0
      this.showPhoneHeader = false
      sessionStorage.setItem('parentId', parentId)
      this.active = item.id
      this.activeName = [item.label, item.menuEnName]
      sessionStorage.setItem(
        'ActiveObj',
        JSON.stringify({
          path: item.modulesType || 'error',
          active: item.id,
          activeName: [item.label, item.menuEnName],
        })
      )
      this.$store.commit({ type: 'SECOND_ID', second_id: item.id })
      sessionStorage.removeItem('detail_obj')
      this.selectModule(item.modulesType || 'error')
    },
        /**路由跳转 */
    selectModule(item) {
   
      let detail_obj = JSON.parse(sessionStorage.getItem('detail_obj'))
      if (detail_obj && detail_obj.path && detail_obj.id) {
        this.$router.push({
          path: `/common/${sessionStorage.getItem('parentId')}/${
            detail_obj.path
          }`,force: true
        })
      } else {
        this.$router.push({
          path: `/common/${sessionStorage.getItem('parentId')}/${item}`,force: true
        })
      }
      console.log(detail_obj && detail_obj.path && detail_obj.id,123,'detail_obj');
      
    },
    activePostion(name) {
      let app_header = document.querySelector(".app_header");
      if (app_header && name == "home") {
        app_header.className = "app_header activePostion";
      } else {
        app_header.className = "app_header ";
      }
    },
    phoneListFun() {
      if (this.showPhoneHeader) {
        this.showPhoneHeader = false;
      } else {
        this.showPhoneHeader = true;
      }
    },
    /**二级菜单点击 */
    childMenuFun(index) {
      if (index == this.menuIndex) {
        this.menuIndex = null;
      } else {
        this.menuIndex = index;
      }
      console.log(index, "index");
    },
    async configKey() {
      let res = await configKeyApi();
      if (res.code == 200) {
        let str = res.data;
        this.PageView = str.toString().padStart(9, "0");
      }
    },
    // 鼠标移出
    mouseoutToStyle() {
      let menuItem = JSON.parse(sessionStorage.getItem("menuItem"));
      let itemList = document.getElementsByClassName("item");
      for (let i = 0; i < itemList.length; i++) {
        const element = itemList[i];
        let time;
        // clearInterval(time);
        if (menuItem.label == element.childNodes[0].innerText) {
          // time = setTimeout(() => {
          element.className = "item actived";
          // }, 1000);
        }
      }
    },
    // 鼠标移入
    mouseoverToStyle() {
      let itemList = document.getElementsByClassName("item");
      for (let i = 0; i < itemList.length; i++) {
        const element = itemList[i];
        element.className = "item";
      }
    },
    /* 获取导航栏 */
    async getMenuTree() {
      let menuTreeApiData = await menuTreeApi();
      if (menuTreeApiData.code == 200) {
        if (!sessionStorage.getItem("parentId")) {
          sessionStorage.setItem("parentId", menuTreeApiData.data[0].id);
        }
        this.menuList = this.phoneMenuList = menuTreeApiData.data || [];
        sessionStorage.setItem(
          "menuList",
          JSON.stringify(menuTreeApiData.data)
        );
      }
    },
    /* 获取banner图 */
    getBanner() {
      getHomeBanner((data) => {
        let banner = data;
        let arr = [];
        if (banner && banner.length > 0) {
          banner.forEach((item) => {
            if (item.bannerType === "0") {
              arr.push(item);
            }
          });
        }
        this.banner_imgArr = arr;
      });
    },
    /* 导航栏跳转 */
    toPath(item) {
      sessionStorage.setItem("menuItem", JSON.stringify(item));
      document.body.scrollTop = 0;
      sessionStorage.setItem("parentId", item.id);
      /**手机端点击导航时让菜单隐藏 */
      this.showPhoneHeader = false;
      if (item.menuEnName == "HOME" || item.menuEnName == "home") {
        this.$router.push({ path: "/" });
      } else {
        sessionStorage.removeItem("ActiveObj");
        sessionStorage.removeItem("detail_obj");
        this.$router.push({ path: "/common/" + item.id });
      }
    },
    /* 设置请求头 */
    getIp() {
      this.ips = window.Internet.baseURL;
      // this.ips = "https://www.gzsxjsbwg.cn/guanwangApi";
      sessionStorage.setItem("ips", this.ips);
    },
    /* banner图鼠标移入移出 */
    mouseOver1() {
      clearInterval(this.time_banner);
      this.time_banner = null;
    },
    mouseLeave1() {
      clearInterval(this.time_banner);
      this.time_banner = setInterval(() => {
        if (this.banner_index >= this.banner_imgArr.length - 1) {
          this.banner_index = 0;
        } else {
          this.banner_index = this.banner_index + 1;
        }
      }, 5000);
    },
    async getOneMenuInfoFun(id) {
      let { data } = await getOneMenuInfo(id);
      this.oneMenuInfo = data;
    },
    idSave(item) {
      sessionStorage.removeItem("detail_obj");
      if (item.menuEnName == "home") {
        this.$router.push({ path: "/" });
      } else {
        sessionStorage.setItem(
          "ActiveObj",
          JSON.stringify({
            path: item.children[0].modulesType || "error",
            active: item.children[0].id,
            activeName: [item.children[0].label, item.children[0].menuEnName],
          })
        );
        this.$store.commit({
          type: "SECOND_ID",
          second_id: item.children[0].id,
        });
        this.$router.push({
          path: "/common/" + item.id + "/" + item.children[0].modulesType,
        });
      }
    },
    idSave1(item, item1) {
      sessionStorage.removeItem("detail_obj");
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: item.modulesType || "error",
          active: item.id,
          activeName: [item.label, item.menuEnName],
        })
      );
      this.$store.commit({ type: "SECOND_ID", second_id: item.id });
      this.$router.push({
        path: "/common/" + item1.id + "/" + item.modulesType,
      });
    },
    openCode() {
      this.ewmDia = true;
    },
  },
};
</script>

<style lang="scss">
html {
  width: 100%;
}
body {
  margin: 0;
  padding: 0;
}
img {
  vertical-align: bottom;
}
#app {
  font-family: "Microsoft YaHei";
  //   text-align: center;
  color: #333;
  position: relative;
  scrollbar-width: 0;
}

*::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

@keyframes animationName {
  from {
    transform: scale(0);
  }

  to {
    transform: scale(1);
  }
}

.app_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2.5rem;
  width: 100vw;
  box-sizing: border-box;

  // background: url("./assets/img/logoTitle.png");
  .logo {
    img {
      width: 129px;
    }
  }

  .app_header_menuList {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: calc(100% - 43.75rem);

    .item {
      cursor: pointer;
      text-align: center;
      padding: 1.4375rem 0 1.375rem;
      position: relative;
      color: #272727;
      &.actived {
        color: #ffc0ba;
        &::after {
          content: "";
          display: inline-block;
          width: 100%;
          height: 2px;
          position: absolute;
          bottom: 0;
          left: 0;
          border-bottom: 0.1875rem solid #947153;
          animation: animationName 0.5s;
        }
        p {
          &.zh {
            color: #947153;
          }
          &.en {
            color: #947153;
          }
        }
      }
      &:hover {
        p {
          &.zh {
            color: #947153;
          }
          &.en {
            color: #947153;
          }
        }
        &::after {
          content: "";
          display: inline-block;
          width: 100%;
          height: 2px;
          position: absolute;
          bottom: 0;
          left: 0;
          border-bottom: 0.1875rem solid #947153;
          animation: animationName 0.5s;
        }
        &.actived {
          color: #fff;
          bottom: 0;
        }
      }

      p {
        margin: 0;
        &.zh {
          font-size: 1rem;
          margin-bottom: 0.75rem;
          // color: #fff;
        }
        &.en {
          font-size: 0.75rem;
          // color: #fff;
        }
      }
    }
  }
}
.app_header.activePostion {
  position: absolute;
  top: 0;
  z-index: 3;
  right: 0;
  .item {
    color: #fff;
  }
}

.commonBanner {
  height: 31.8125rem;
}
.banner_scroll {
  position: relative;
  width: 100%;
  // min-width: 80rem;
  ul {
    padding: 0;
    position: relative;
    overflow: hidden;
    height: calc(100vh - 6.25rem);
    margin: 0;
    li {
      list-style: none;
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      img {
        width: 100%;
        display: block;
      }
    }
    li.default_li {
      transform: scale(1, 1);
      opacity: 0;
      z-index: -1;
      transition: opacity 1000ms linear 0s;
    }
    li.actived_li {
      transform: scale(1.05, 1.05);
      opacity: 1;
      z-index: 0;
      transition: transform 5000ms linear 0s, opacity 1000ms linear 0s;
    }
  }
  .bannerMenuBack {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4.25rem;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    font-size: 0.875rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    .bannerMenu {
      display: flex;
      align-items: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      .item {
        cursor: pointer;
        &:hover {
          color: #cda812;
        }
      }
      img {
        margin: 0 1.875rem;
      }
    }
  }
}
.footer_style {
  background: #272727;
  color: rgba(223, 223, 223, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  // height: 167px;
  height: 250px;
  position: relative;
  // min-width: 80rem;

  width: 100%;
  .institution {
    position: absolute;
    left: 60%;
    top: 36px;
  }
  .footer_left {
    padding-top: 20px;
    padding-right: 2.625rem;
    text-align: center;
    // padding-top: 45px;
    div {
      margin-bottom: 1.125rem;
    }
  }
  .GovernmentLink {
    display: flex;
    margin-bottom: 0 !important;
    p {
      margin: 0;
    }
    a {
      color: #fff;
      margin: 0 20px;
      width: 200px;
      height: 50px;
      display: inline-block;
      background: url("./assets/img/LiupanshuiGovernment.jpg") no-repeat;
    }
    .gzmuseum {
      background: url("./assets/img/GuizhouProvincialMuseum.jpg") no-repeat;
    }
    .zhonshan {
      background: url("./assets/img/ZhongshanDistrictPeoplesGovernment.jpg")
        no-repeat;
    }
  }
  .footer_right {
    display: flex;
    justify-content: space-between;
    margin-top: 2.5rem;
    ul li.li_first {
      color: #ffffff;
      font-size: 1rem;
    }
    ul {
      margin: 0;
    }
    ul li {
      list-style: none;
      margin-bottom: 1.125rem;
      font-size: 0.875rem;
      font-weight: bold;
      color: #b5b5b5;
      text-align: left;
      cursor: pointer;
      a {
        color: #dfdfdf;
        text-decoration: none;
      }
      &:hover {
        a {
          color: #947153;
        }
      }
    }
    .footer_selected {
      margin-left: 1.875rem;
      .el-input {
        width: 16.5rem;
        height: 2.5rem;
        input {
          border-radius: 0;
          background: rgba(130, 107, 97, 1);
          color: #fff;
          border: none;
        }
      }
    }
  }
}
.stickiness {
  position: fixed;
  top: 50%;
  right: 0;
  z-index: 10000;
  .greyBox {
    width: 3.75rem;
    height: 3.25rem;
    background: #3b3d3d;
    opacity: 0.6;
    margin-bottom: 0.125rem;
    padding-top: 0.5rem;
    color: #fff;
    text-align: center;
  }
}
.ewmDiv {
  text-align: center;
}
@media screen and (max-width: 102.5rem) {
  .app_header {
    // width: 87.5rem;
  }
}
@media screen and (max-width: 87.5rem) {
  .app_header {
    // width: 80rem;
  }
}
.PageView {
  color: #acabaf;
  padding: 0 4px;
  margin: 0 6px;
  background: #404040;
}
.beanhao {
  a {
    color: #dfdfdf;
  }
  img {
    vertical-align: middle;
  }
}
ul {
  list-style: none;
}
.phoneLogo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px;
  h3{
    font-size: 24px;
        font-weight: 600;
        color: #3f200c;
  }
}
.headerBottom {
  // position: fixed;
  top: 62.2px;
  // width: 100%;
  padding: 0 12px;
  box-sizing: border-box;
  // background: #000;
  opacity: 0.9;
  height: 35px;
  z-index: 999999;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .newList {
    flex: 1;
    color: #141313;
    display: flex;
    align-items: center;
    font-size: 13px;
    span {
      min-width: 30px;
      text-align: left;
      margin-right: 30px;
      &:nth-last-child(1) {
        margin-right: 0;
      }
    }
  }
  .phoneList {
    height: 4px;
    width: 30px;
    padding-left: 10px;
    .line {
      display: block;
      width: 30px;
      background: #000;
      height: 3px;
      position: relative;
      transition: all 0.3s;
      &::before {
        content: "";
        display: block;
        width: 30px;
        background: #000;
        height: 3px;
        position: absolute;
        top: 6px;
        transition: all 0.3s;
      }
      &::after {
        content: "";
        display: block;
        width: 30px;
        background: #000;
        height: 3px;
        position: absolute;
        bottom: 6px;
        transition: all 0.3s;
      }
      &.active {
        background: transparent;
        &::before {
          top: 0px;
          transform: rotate(-45deg);
        }
        &::after {
          bottom: 0px;
          transform: rotate(45deg);
        }
      }
    }
  }
}
.phoneMenuList {
  position: sticky;
  top: 90.2px;
  left: 0;
  right: 0;
  background: url('../src/assets/img/ydbg2.png');
  background-size: cover;
  background-repeat: no-repeat;
  z-index: 9;
  color: #fff;
  transition: all 0.4s;
  height: 0;
  overflow: hidden auto;
  font-size: 13px;
  &.active {
    // height: calc(100% - 97.2px);
    height: 100vh;
  }
  .firstItem {
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    &:nth-child(1) {
      border-top: 1px solid rgba(255, 255, 255, 0.2);
    }
    .one {
      padding: 0 0 0 15px;
      text-align: left;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .txt {
        flex: 1;
        height: 45px;
        line-height: 45px;
      }
      .icon {
        width: 55px;
        height: 45px;
        line-height: 45px;
        text-align: center;
        transition: all 0.4s;
        &.active {
          transform: rotate(180deg);
        }
      }
    }
    .two {
      height: 0;
      overflow: hidden;
      transition: all 0.4s;
      &.active {
        height: auto;
      }
      .item {
        height: 45px;
        line-height: 45px;
        // text-align: center;
        padding-left: 30px;
        border-top: 1px solid rgba(255, 255, 255, 0.2);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue